// Iamges & Syles
import './images'
import './stylesheets/app.scss'

// Custom JS
import './devise'
import './faq'
import './miles-cards'
import './miles-popup'



// WEBPACK FOOTER //
// app/javascript/frontend/index.js